import React from 'react';
import { BuilderBlocks, BuilderElement } from '@builder.io/react';

interface ContentBlockProps {
  content: BuilderElement[];  
  topSpacing?: string;
  bottomSpacing?: string;
  builderBlock: BuilderElement;
}

export const ContentBlock = ({ content, builderBlock, topSpacing, bottomSpacing }: ContentBlockProps) => {
  const spaceMap = {
    none: '0px',
    small: '12px',
    medium: '24px',
    large: '48px',
    xlarge: '60px',
  };
  const topSpacingClass = topSpacing ? `mt-[${spaceMap[topSpacing as keyof typeof spaceMap]}]` : '';
  const bottomSpacingClass = bottomSpacing ? `mb-[${spaceMap[bottomSpacing as keyof typeof spaceMap]}]` : '';

  return (
    <section className={`${topSpacingClass} ${bottomSpacingClass}`}> 
      <BuilderBlocks
        parentElementId={builderBlock?.id}
        dataPath="content"
        blocks={content ?? []}
        className="flex flex-col gap-6"
      />  
    </section>
  );
}; 